/* global Raven:true */
'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.errorlog.service
 * @description
 * # errorlog.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .factory('errorlogService', function($log, $window, $injector, moment, uuid4, ravenService) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
      //var raven = ravenService.Raven();



      // NOTE: In production, I have some debouncing
      // logic here to prevent the same client from
      // logging the same error over and over again! All
      // that would do is add noise to the log.
      try {
        Raven.captureException(exception);
      } catch (loggingError) {
        // For Developers - log the log-failure.
        $log.warn('Error logging failed');
        $log.log(loggingError);
      }
    };
  });
